export const Wordmark = ({ className = "" }) => (
  <span className={`select-none leading-none whitespace-nowrap ${className}`}>
    <span className="font-display font-medium tracking-tight">Maison</span>{" "}
    <span className="font-petit text-[1.15em] relative -top-[0.06em]">R</span>
    <span className="font-display italic font-medium tracking-tight relative -left-[0.08em]">
      ia
    </span>
  </span>
);

export const Monogram = ({ className = "" }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
    <text
      x="24"
      y="36"
      textAnchor="middle"
      fontFamily="'Petit Formal Script', cursive"
      fontSize="34"
      fill="currentColor"
    >
      R
    </text>
  </svg>
);
